/**
 * Lightweight logger utility with level-based output and contextual metadata.
 *
 * - Uses console under the hood; no external deps.
 * - Debug logs are shown only in development.
 * - Accepts optional context objects to keep logs consistent.
 */
class Logger {
  static _shouldDebug() {
    return process.env.NODE_ENV === 'development';
  }

  static _buildArgs(level, message, context) {
    if (context && Object.keys(context).length > 0) {
      return [`[${level}] ${message}`, context];
    }
    return [`[${level}] ${message}`];
  }

  static debug(message, context = {}) {
    if (!this._shouldDebug()) return;
    console.debug(...this._buildArgs('DEBUG', message, context));
  }

  static info(message, context = {}) {
    console.info(...this._buildArgs('INFO', message, context));
  }

  static warn(message, context = {}) {
    console.warn(...this._buildArgs('WARN', message, context));
  }

  static error(message, context = {}) {
    console.error(...this._buildArgs('ERROR', message, context));
  }
}

export default Logger;

